import { cleanObject } from 'src/app/utils/cleanObject';
import { deepOmit } from 'src/app/utils/deepOmit';
import type { DraftJob, UpdateDraftJobInput } from 'src/graphql/generated';

export const mapToUpdateDraftJobInput = ({
  draftJob,
  flowType,
  status,
}: {
  draftJob: DraftJob;
  flowType: UpdateDraftJobInput['flowType'];
  status: UpdateDraftJobInput['status'];
}): UpdateDraftJobInput =>
  cleanObject(
    deepOmit('__typename', {
      applicationFormUrl: draftJob.applicationFormUrl,
      branding: draftJob.branding,
      categories: draftJob.categories,
      details: draftJob.details,
      draftProgress: draftJob.draftProgress,
      expiresAt: draftJob.expiresAt,
      flowType,
      guidedDetails: draftJob.guidedDetails,
      hasAIAssistanceBeenUsed: draftJob.hasAIAssistanceBeenUsed,
      id: draftJob.id,
      isConfidential: draftJob.isConfidential,
      jobAdReference: draftJob.jobAdReference,
      jobWritingMode: draftJob.jobWritingMode,
      keySellingPoints: draftJob.keySellingPoints,
      locations: draftJob.locationsV2,
      paymentOption: draftJob.paymentOption,
      phoneNumber: draftJob.phoneNumber,
      products: draftJob.products,
      questionnaireId: draftJob.questionnaireId,
      salary: draftJob.salary,
      status,
      summary: draftJob.summary,
      titles: draftJob.titles,
      video: draftJob.video,
      workTypes: draftJob.workTypes,
    }),
  );
